import { Flex, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { RootState, useAppDispatch, useAppSelector } from "../../store";
import { fetchAnaliseRecruiter, setCurrentCustomer, setSelectedCustomer } from "../../store/slices/analytics";
import DateRangePicker from "../DateRangePicker/DateRangePicker";
import Select from "react-select"
import { fetchCustomers } from "../../store/slices/customers";
import { AnalyticsFilters } from "../AnalyticsBlocks/AnalyticsFilters";
import { colourStylesCustomer } from "../AnalyticsBlocks/filterStyles";


export const RecruiterAnalytics = ({ isActive }: { isActive: boolean }) => {
    const { recruiterAnalise, period_from, period_to, customer, currentDepartment, currentChannel, selectedCustomer } = useAppSelector(
        (state: RootState) => state.analytics
    );
    const { customers } = useAppSelector(
        (state: RootState) => state.customers
    );
    const [customerList, setCustomerList] = useState<{ value: string, label: string }[]>([])

    useEffect(() => {
        if (customers) {
            const resultCustomers = customers.items.map((el) => ({ value: String(el.id), label: el.name }));
            resultCustomers.unshift({ value: "all", label: "Все" })
            setCustomerList(resultCustomers)
        }
    }, [customers])

    const dispatch = useAppDispatch();
    useEffect(() => {
        dispatch(fetchCustomers({ params: { filters: { limit: "100000", offset: "0" } } }))
        // Убираем сброс фильтров при размонтировании компонента, чтобы сохранить состояние между вкладками
    }, [dispatch])

    // Инициализация сохраненных значений фильтров при первой загрузке
    useEffect(() => {
        if (selectedCustomer === null && customerList.length > 0) {
            dispatch(setSelectedCustomer("all"));
        }
    }, [dispatch, selectedCustomer, customerList.length]);

    useEffect(() => {
        if (isActive) {
            dispatch(fetchAnaliseRecruiter({ period_from: period_from, period_to: period_to, customer_id: customer, department_id: currentDepartment === 0 ? null : currentDepartment, channel_id: currentChannel === 0 ? null : currentChannel }))
        }
    }, [period_from, period_to, customer, currentDepartment, dispatch, isActive, currentChannel]);


    return (
        <Flex flexDirection="column">
            <AnalyticsFilters 
                isActive={isActive}
                additionalFilters={
                    <>
                        <DateRangePicker />
                        <Select
                            menuPosition="fixed"
                            className="basic-single"
                            classNamePrefix="select"
                            isSearchable={false}
                            name="customer"
                            styles={colourStylesCustomer}
                            options={customerList}
                            placeholder="Выберите заказчика"
                            value={customerList.find(item => item.value === (selectedCustomer || "all")) || null}
                            onChange={(arg) => {
                                if (arg) {
                                    dispatch(setSelectedCustomer(arg.value));
                                    dispatch(setCurrentCustomer(arg.value === "all" ? null : Number(arg.value)));
                                }
                            }}
                        />
                    </>
                }
            />
            
            <Text fontSize="27px" fontWeight={600} color="#3b515e" marginTop="16px">
                Аналитика по рекрутерам
            </Text>

            <Flex flexDirection="column" gap="24px" marginTop="16px">
                {recruiterAnalise.map((rec) => {
                    let total_count = 0;
                    let interview_count = 0;
                    let success_interview_count = 0;
                    let exists_count = 0;
                    rec.vacancies.forEach((el) => {
                        total_count += el.total_count
                        interview_count += el.interview_count
                        success_interview_count += el.success_interview_count
                        exists_count += el.exists_count
                    })
                    
                    return (
                        <Flex key={rec.id} flexDirection="column" bgColor="white" borderRadius="8px" border="1px solid #e1e7ef" padding="16px">
                            <Text fontSize="24px" fontWeight={600} color="#3b515e" marginBottom="16px">
                                {rec.name}
                            </Text>
                            
                            {/* Шапка таблицы */}
                            <Flex w="100%" borderBottom="2px solid #e1e7ef" paddingBottom="12px">
                                <Flex flex="2" paddingLeft="12px">
                                    <Text fontSize="16px" fontWeight={600} color="#3b515e">
                                        Название вакансии
                                    </Text>
                                </Flex>
                                <Flex flex="1" justifyContent="center">
                                    <Text fontSize="16px" fontWeight={600} color="#3b515e">
                                        Направленные
                                    </Text>
                                </Flex>
                                <Flex flex="1" justifyContent="center">
                                    <Text fontSize="16px" fontWeight={600} color="#3b515e">
                                        Собеседования
                                    </Text>
                                </Flex>
                                <Flex flex="1" justifyContent="center">
                                    <Text fontSize="16px" fontWeight={600} color="#3b515e">
                                        Успешные
                                    </Text>
                                </Flex>
                                <Flex flex="1" justifyContent="center">
                                    <Text fontSize="16px" fontWeight={600} color="#3b515e">
                                        Выходы
                                    </Text>
                                </Flex>
                                <Flex flex="1" justifyContent="center">
                                    <Text fontSize="16px" fontWeight={600} color="#3b515e">
                                        Конверсия
                                    </Text>
                                </Flex>
                            </Flex>

                            {/* Строки таблицы */}
                            <Flex flexDirection="column" w="100%" gap="4px" marginTop="8px">
                                {rec.vacancies.map((vac) => (
                                    <Flex
                                        key={vac.id}
                                        w="100%"
                                        alignItems="center"
                                        padding="12px"
                                        borderRadius="4px"
                                        sx={{
                                            "&:hover": {
                                                backgroundColor: "#f7f9fc",
                                            },
                                        }}
                                    >
                                        <Flex flex="2">
                                            <Text fontSize="16px" color="#3b515e" fontWeight={500}>
                                                {vac.name}
                                            </Text>
                                        </Flex>
                                        <Flex flex="1" justifyContent="center">
                                            <Text fontSize="16px" color="#3b515e">
                                                {vac.total_count}
                                            </Text>
                                        </Flex>
                                        <Flex flex="1" justifyContent="center">
                                            <Text fontSize="16px" color="#3b515e">
                                                {vac.interview_count}
                                            </Text>
                                        </Flex>
                                        <Flex flex="1" justifyContent="center">
                                            <Text fontSize="16px" color="#3b515e">
                                                {vac.success_interview_count}
                                            </Text>
                                        </Flex>
                                        <Flex flex="1" justifyContent="center">
                                            <Text fontSize="16px" color="#3b515e">
                                                {vac.exists_count}
                                            </Text>
                                        </Flex>
                                        <Flex flex="1" justifyContent="center">
                                            <Text fontSize="16px" color="#3b515e">
                                                {vac.conversion ? `${vac.conversion}%` : "-"}
                                            </Text>
                                        </Flex>
                                    </Flex>
                                ))}
                                
                                {/* Итоговая строка */}
                                <Flex
                                    w="100%"
                                    alignItems="center"
                                    padding="12px"
                                    borderRadius="4px"
                                    borderTop="1px solid #e1e7ef"
                                    marginTop="8px"
                                    backgroundColor="#f8f9fa"
                                >
                                    <Flex flex="2">
                                        <Text fontSize="16px" color="#3b515e" fontWeight={700}>
                                            Всего:
                                        </Text>
                                    </Flex>
                                    <Flex flex="1" justifyContent="center">
                                        <Text fontSize="16px" color="#3b515e" fontWeight={700}>
                                            {total_count}
                                        </Text>
                                    </Flex>
                                    <Flex flex="1" justifyContent="center">
                                        <Text fontSize="16px" color="#3b515e" fontWeight={700}>
                                            {interview_count}
                                        </Text>
                                    </Flex>
                                    <Flex flex="1" justifyContent="center">
                                        <Text fontSize="16px" color="#3b515e" fontWeight={700}>
                                            {success_interview_count}
                                        </Text>
                                    </Flex>
                                    <Flex flex="1" justifyContent="center">
                                        <Text fontSize="16px" color="#3b515e" fontWeight={700}>
                                            {exists_count}
                                        </Text>
                                    </Flex>
                                    <Flex flex="1" justifyContent="center">
                                        <Text fontSize="16px" color="#3b515e" fontWeight={700}>
                                            {rec.conversion}%
                                        </Text>
                                    </Flex>
                                </Flex>
                            </Flex>
                        </Flex>
                    );
                })}
            </Flex>
        </Flex>
    );
}